<template>
  <div id="app">
    <!-- <generic-nav></generic-nav> -->
    <advanced-nav></advanced-nav>
    <router-view class="body"/>
    <Footer /> 
  </div>
</template>

<script>

// import GenericNav from '@/components/Nav/GenericNav';
import AdvancedNav from '@/components/Nav/AdvancedNav';
import Footer from '@/components/Nav/Footer';

export default {
  name: "App",
  data() {
    return {
      search: "",
      progressValue: 100
    };
  },
  created() {

  },
  computed: {
    userInfo() {
      return this.$store.state.auth.userInfo;
    },
    cartCount() {
      return this.$store.state.cart.length;
    },
    CompanyName() {
      return process.env.COMPANY_NAME;
    },
    CompanyNameShort() {
      return process.env.COMPANY_NAME_SHORT;
    },
    CompanySlogan() {
      return process.env.COMPANY_SLOGAN;
    }
  },
  methods: {
    Signout() {
      this.$store.commit("ClearCredentials");
      this.$router.push({ path: "/" });
    },
    searchProducts() {
      var query = "";
      if (this.search) {
        if (this.userInfo) {
          query = "Contains(ProductService.Name, '" + this.search + "')";
        } else {
          query = "Contains(Name, '" + this.search + "')";
        }
      }
      this.$router.push({ path: "/Products", query: { q: query } });
    },
    openCart() {
      this.$router.push({ path: "/cart" });
    },
    // SearchProductByTag(tag) {
    //   var query = "";
    //   if (this.userInfo) {
    //     query = "[ProductService.Tags][Name = '" + tag + "']";
    //   } else {
    //     query = "[Tags][Name = '" + tag + "']";
    //   }
    //   this.$router.push({ path: "/Products", query: { q: query } });
    // }
  },
  components: {
    // GenericNav,
    AdvancedNav,
    Footer
  }
};
</script>

<style>
html,
body {
  height: 100%;
}

.footer {
  /* position: absolute; */
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
}

#nprogress .bar {
  background: #dcdde1;
  height: 3px;
}

#nprogress .peg {
  display: block;
  position: absolute;
  right: 0px;
  width: 100px;
  height: 100%;
  box-shadow: 0 0 10px #dcdde1, 0 0 5px #dcdde1;
  opacity: 1;

  -webkit-transform: rotate(3deg) translate(0px, -6px);
  -ms-transform: rotate(3deg) translate(0px, -6px);
  transform: rotate(3deg) translate(0px, -6px);
}

#nprogress .spinner-icon {
  border-top-color: #dcdde1;
  border-left-color: #dcdde1;
}

#app {
  min-height: 100%;
  position: relative;
}

.body {
  padding-bottom: 200px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue